import { computed } from "mobx";
import * as moment from "moment";

import Entity from "lib/models/Entity";

interface NewsSource {
  id: number;
  title: string;
  source?: string;
  imageUrl?: string;
  originalUrl: string;
  publishedDate?: string;
  summary?: string;
  isChecked?: boolean;
  isDismissed?: boolean;
  isDismissedByAi?: boolean;
  sourceImageUrl: string;
  tags?: number[];
  tagsByAi?: number[];
}

export default class News extends Entity<NewsSource> {
  @computed
  get title(): string {
    return this.source.title;
  }

  @computed
  get sourceFrom(): string {
    return this.source.source || "";
  }

  @computed
  get imageUrl(): string {
    return this.source.imageUrl || "";
  }

  @computed
  get originalUrl(): string {
    return this.source.originalUrl;
  }

  @computed
  get publishedDate(): string {
    return moment(this.source.publishedDate).format("lll");
  }

  @computed
  get summary(): string {
    return this.source.summary || "";
  }

  @computed
  get isChecked(): boolean {
    return this.source.isChecked || false;
  }

  @computed
  get isDismissed(): boolean {
    return this.source.isDismissed || false;
  }

  @computed
  get isDismissedByAi(): boolean {
    return this.source.isDismissedByAi || false;
  }

  @computed
  get sourceImageUrl(): string {
    return this.source.sourceImageUrl || "";
  }

  @computed
  get tags(): number[] {
    return this.source.tags || [];
  }

  @computed
  get tagsByAi(): number[] {
    return this.source.tagsByAi || [];
  }
}

export type { NewsSource };
